import { ScheduleType, DayOfWeekSchedule } from "../enums";
import { Timeframe } from "../..";
import { ProductScheduleSettingsBuilder } from "../builders";

export class ProductScheduleSettings {
  public readonly type: ScheduleType;
  public readonly blackout: string[];
  public readonly dow: DayOfWeekSchedule;
  public readonly availability: Timeframe;

  constructor(builder: ProductScheduleSettingsBuilder) {
    this.type = builder.type;
    this.blackout = builder.blackout;
    this.dow = builder.dow;
    this.availability = builder.availability;
  }

  toJSON = () => ({
    type: this.type == null ? ScheduleType.None : this.type,
    blackout: this.blackout ? this.blackout : null,
    dow: this.type === ScheduleType.DayOfWeek ? this.dow.toJSON() : null,
    availability: this.availability ? this.availability.toJSON() : null
  });
}
